import { useEffect, useState } from 'react'

/** Example hook**/
export function useWindowResize() {
  const isClient = typeof window === 'object'
  const [windowSize, setWindowSize] = useState( {
    width: isClient ? window.innerWidth : undefined,
    height: isClient ? window.innerHeight : undefined
  } )
  useEffect( () => {
    const handler = ( e ) => {
      if ( e.key === "f" ) {
        document.body.style.backgroundColor = "Pink"
      } else {
        document.body.style.backgroundColor = ""
      }
    }
    window.addEventListener( 'keyup', handler )
    return () => {
      window.removeEventListener( 'keyup', handler )
      document.body.style.backgroundColor = ""
    }
  }, [] )

  useEffect( () => {
    if ( !isClient ) return
    const handle = () => {
      setWindowSize( {
        width: window.innerWidth,
        height: window.innerHeight
      } )
    }
    window.addEventListener( 'resize', handle )
    return () => {
      window.removeEventListener( 'resize', handle )
    }
  }, [isClient] )
  return windowSize
}
